import { Alert } from '@side/pantry';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { TrackOfferEvent } from '$analytics/useTrackAnalytics/domains/offers/events';
import { useTrackOfferAnalytics } from '$analytics/useTrackAnalytics/domains/offers/useTrackOfferAnalytics';
import { useCreateOfferContext } from '../context/CreateOfferContext';
import type { CreateOfferFormData } from '../types';

export const LinkedListingAlert = () => {
  const { openedFromListing } = useCreateOfferContext();
  const [dismissed, setDismissed] = useState(false);
  const listingId = useWatch<CreateOfferFormData, 'listingId'>({
    name: 'listingId',
  });
  const trackOfferEvent = useTrackOfferAnalytics();

  useEffect(() => {
    if (openedFromListing) {
      trackOfferEvent(TrackOfferEvent.LinkedListingAlertMount, { listingId });
    }
  }, [openedFromListing, listingId, trackOfferEvent]);

  if (!openedFromListing || dismissed) return null;

  return (
    <Alert
      severity="info"
      onClose={() => {
        trackOfferEvent(TrackOfferEvent.DismissLinkedListingAlert, {
          listingId,
        });
        setDismissed(true);
      }}
      sx={{ mb: { xs: 2, lg: 3 } }}
    >
      Create and send the offer package for signature before logging it on your
      Listing
    </Alert>
  );
};
